import { render, staticRenderFns } from "./contact.view.vue?vue&type=template&id=2a4f427e"
import script from "./contact.view.vue?vue&type=script&lang=js"
export * from "./contact.view.vue?vue&type=script&lang=js"
import style0 from "./contact.view.vue?vue&type=style&index=0&id=2a4f427e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports